import React from 'react';

import { Button, Icon } from '../../../components/common';
import {
  BoxReplicate,
  FlexCol,
  FlexRow,
  Footer,
  H2,
  ReplicateSubtitle,
  ReplicateTitle
} from '../style';
import MultiSelect from '../../../components/common/SelectMultiple';

const StepDestiny = ({
  handleChange,
  valueDestiny,
  handleChangeReplicateDestiny,
  isMultistore,
  optionSelected,
  handleChangeStores,
  stores
}) => {
  return (
    <>
      <H2>Qual o destino da réplica?</H2>
      <FlexRow>
        <BoxReplicate
          className={valueDestiny === 'all_units' ? 'selected' : ''}
          onClick={() => handleChangeReplicateDestiny('all_units')}
        >
          <Icon
            width={'56px'}
            height={'56px'}
            name={'replicateStoreCheck'}
            stroke={'primary'}
          />
          <ReplicateTitle>Todas as Unidades</ReplicateTitle>
          <ReplicateSubtitle>Todas as unidades receberão a réplica.</ReplicateSubtitle>
        </BoxReplicate>
        <BoxReplicate
          className={valueDestiny === 'search_unit' ? 'selected' : ''}
          onClick={() => handleChangeReplicateDestiny('search_unit')}
        >
          <Icon
            width={'56px'}
            height={'56px'}
            name={'replicateStoreSearch'}
            stroke={'primary'}
          />
          <ReplicateTitle>Selecionar Unidade</ReplicateTitle>
          <ReplicateSubtitle>
            Uma ou mais unidades específicas receberão a réplica.
          </ReplicateSubtitle>
        </BoxReplicate>
      </FlexRow>
      <FlexCol>
        {console.log(stores)}
        {stores && stores.length > 0 && valueDestiny === 'search_unit' && (
          <MultiSelect
            key="select_stores_id"
            options={stores.map((store) => {
              return {
                value: store.id,
                label: store.name
              };
            })}
            onChange={handleChangeStores}
            value={optionSelected}
            isSelectAll={true}
            menuPlacement={'bottom'}
          />
        )}
      </FlexCol>
      <Footer>
        <Button
          className="default-error"
          width={'80px'}
          onClick={() => handleChange('origin')}
        >
          Cancelar
        </Button>
        <Button
          disabled={!valueDestiny}
          className="success"
          width={'80px'}
          onClick={() => handleChange('summary')}
        >
          Continuar
        </Button>
      </Footer>
    </>
  );
};

export default StepDestiny;
